module.exports = __webpack_public_path__ + "assets/JTUSjIg1_i6t8kCHKm459Wlhyw-e6e558.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/JTUSjIg1_i6t8kCHKm459Wlhyw.woff2
// module id = 848
// module chunks = 2